module.exports = __webpack_public_path__ + "img/arrowLeft.2a342515.svg";